export { getStoresServerAction } from 'next-flight-server-reference-proxy-loader?id=70485c6f24c5561dd01302bb74300fd91562f3b8ae&name=getStoresServerAction!'